
import { VideoType, VideoStyle, CtaOption } from './types';

export const VIDEO_TYPE_OPTIONS: VideoType[] = [
  VideoType.Vehicle,
  VideoType.Trending,
];

export const VIDEO_STYLE_OPTIONS: VideoStyle[] = [
  VideoStyle.Funny,
  VideoStyle.Informative,
  VideoStyle.Luxury,
  VideoStyle.Action,
  VideoStyle.Storytelling,
  VideoStyle.QuickTip,
  VideoStyle.BehindTheScenes,
  VideoStyle.DayInTheLife,
  VideoStyle.Comparison,
];

export const CTA_OPTIONS: CtaOption[] = [
  CtaOption.Comment,
  CtaOption.TestDrive,
  CtaOption.VisitWebsite,
  CtaOption.Follow,
  CtaOption.Share,
  CtaOption.ContactUs,
];